<template>
    <div class="body-padding tracking-detail" style="overflow: scroll; -webkit-overflow-scrolling: touch;">
        <div class="container" ref="imageDom">
            <div class="tracking-detail__info">
                <div class="info-flex info-padding info-title">
                    <div class="generating">运单详情</div>
                    <van-button
                            v-show="!generating"
                            class="follow-btn"
                            type="warning"
                            size="small"
                            @click.stop="clickLogistics"
                    >物流跟踪
                    </van-button>
                </div>
                <div class="info-flex info-padding info-content">
                    <span>运单号：</span>
                    <span>{{ detail.trackingNumber }}
                        <van-icon
                                class="btn-copy"
                                name="description"
                                v-show="detail.trackingNumber"
                                @click.stop="handleCopyClick(detail.trackingNumber, '运单号')"
                                size="0.4rem"></van-icon>
                </span>
                </div>
                <div class="info-flex info-padding info-content">
                    <span>开单时间：</span>
                    <span>{{ detail.createDate }}</span>
                </div>
                <div class="info-flex info-padding info-content">
                    <span style="font-weight: bold;color:#042D6F;">运单状态：</span>
                    <span style="font-weight: bold;color:#042D6F;">{{ detail.isConfirmGoods ? '已收到货' : detail.statusName }}</span>
                </div>

                <address-item type="tracking" :detail="detail" v-show="detail.status!='75'"></address-item>

                <div class="info-flex info-padding info-service" v-show="detail.status!='75'">
                    <span>服务方式：</span>
                    <span>{{ detail.deliveryName }}</span>
                </div>
            </div>

            <div class="tracking-detail__goods" v-show="detail.status!='75'">
                <van-collapse v-model="activeName">
                    <van-collapse-item title="货物信息" name="1">
                        <div class="service-item">
                            <span>品名：{{ detail.productName }}</span>
                            <span>重量：{{ detail.weight }}kg</span>
                        </div>
                        <div class="service-item">
                            <span>包装：{{ detail.packName }}</span>
                            <span>体积：{{ detail.volume }}m³</span>
                        </div>
                        <div class="service-item">
                            <span>件数：{{ detail.goodsNumber }}</span>
                            <span></span>
                        </div>
                    </van-collapse-item>
                </van-collapse>
            </div>

            <div class="tracking-detail__pay" v-show="detail.status!='75'">
                <van-collapse v-model="activeName">
                    <van-collapse-item title="费用信息" name="2">
                        <div class="pay-item">
                            <span>付款方式：</span>
                            <span>{{ detail.payMeansName }}</span>
                        </div>
                        <div class="pay-item">
                            <span>运费总额：</span>
                            <span>{{ detail.totalFee }}元</span>
                        </div>
                        <div class="pay-item">
                            <span>代收货款：</span>
                            <span>{{ detail.collectMoney }}元</span>
                        </div>
                        <div class="pay-item" v-if="detail.couponDescribe!=''">
                            <span>应付：</span>
                            <span>{{detail.yingfu}}</span>
                        </div>
                        <div class="pay-item" v-if="detail.discountAmount">
                            <span>优惠金额：</span>
                            <span>{{detail.discountAmount}}</span>
                        </div>
                        <div class="pay-item" v-if="detail.payAmount">
                            <span>实付金额：</span>
                            <span>{{detail.payAmount}}</span>
                        </div>
                    </van-collapse-item>
                </van-collapse>
            </div>
            <van-image-preview v-model="show" :images="images" @change="onChange">
                <template v-slot:index>{{ index }}/{{ index }}</template>
            </van-image-preview>
            <div class="payment-btn" v-if="isPayShow&&$route.query.t">
                <div class="left">
                    <p>合计:<span> ￥</span><span>{{ detail.yingfu }}</span></p>
                    <p class="border"></p>
                    <p>已优惠<span>{{detail.value==0?'0':detail.value}}</span>元</p>
                </div>
                <van-button type="default" class="right-btn" @click="gopayment">去支付
                </van-button>
            </div>
            <!--        <div style="padding-top: .25rem">-->
            <!--            <van-button class="btn-spacing-4" @click="checkDeliveryCode" type="warning" size="large">查看提货码</van-button>-->
            <!--        </div>-->
        </div>
        <div style="text-align: center;margin-bottom: 1.5rem;">
            <van-button
                    class="voucher-btn"
                    type="warning"
                    size="small"
                    @click.stop="clickGeneratePicture">转发凭证
            </van-button>
        </div>
    </div>
</template>

<script>
    import {Toast} from 'vant'
    import html2canvas from 'html2canvas'

    export default {
        name: "MyWayBillDetail",
        components: {
            AddressItem: () => import('./components/AddressItem')
        },
        data() {
            return {
                id: this.$route.query.id,
                trackingId: this.$route.query.trackingId,
                flag: this.$route.query.flag,
                detail: {},
                activeName: ['1', '2'],
                imgUrl: null,
                show: false,
                index: 0,
                images: [],
                generating: false
            }
        },
        created() {
            this.getDetail();
        },
        computed: {
            isPayShow() {
                let show = false
                if (this.detail.statusName == '已取消' || this.detail.status == 75) {
                    return show
                }
                if (this.detail.payStatus == 0 && this.detail.payMeansId == 1 && this.flag == 1) {
                    show = true
                } else if (this.flag == 2) {
                    if (this.detail.payMeansId == 2 && ((this.detail.collectionPayStatus == 0 && this.detail.collectMoney != 0) || this.detail.payStatus == 0 && this.detail.totalFee != 0)) {
                        show = true
                    } else if (this.detail.payMeansId == 1 && this.detail.collectionPayStatus == 0 && this.detail.collectMoney != 0) {
                        show = true
                    }
                }
                return show
            },
        },
        methods: {
            onChange(index) {
                this.index = index;
            },
            /**
             * 将页面指定节点内容转为图片
             * 1.拿到想要转换为图片的内容节点DOM；
             * 2.转换，拿到转换后的canvas
             * 3.转换为图片
             */
            clickGeneratePicture() { //生成图片
                this.generating = true;
                this.$nextTick(() => {
                    html2canvas(this.$refs.imageDom).then(canvas => {
                        this.generating = false;
                        this.title = '运单详情';
                        // 转成图片，生成图片地址
                        const imgUrl = canvas.toDataURL("image/png"); //可将 canvas 转为 base64 格式
                        const ctx = canvas.getContext('2d');
                        const image = new Image();
                        image.onload = () => {
                            const imgWidth = document.body.offsetWidth * 2;
                            const imgHeight = imgWidth / image.width * image.height;
                            const titleHeight = document.querySelector('.app-header').offsetHeight * 2; // title 高度
                            let titleFontSize = getComputedStyle(document.querySelector('.app-header')).fontSize; // title 文字大小
                            titleFontSize = titleFontSize.slice(0, titleFontSize.indexOf('px')) * 2;
                            canvas.width = imgWidth;
                            canvas.height = imgHeight + titleHeight; // 设置canvas大小, canvas预留title位置
                            ctx.fillStyle = '#042D6F';
                            ctx.fillRect(0, 0, imgWidth, imgHeight); // 填充canvas背景色
                            ctx.font = `${titleFontSize}px Helvetica Neue, Helvetica, Microsoft YaHei`;
                            ctx.fillStyle = '#fff';
                            const fontWidth = ctx.measureText('电子面单').width;
                            ctx.fillText('电子面单', imgWidth / 2 - fontWidth / 2, titleHeight / 2 + (titleFontSize / 2));
                            ctx.drawImage(image, 0, titleHeight, imgWidth, imgHeight);
                            this.imgUrl = canvas.toDataURL('image/png');
                            let isWxLogin = window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
                            if (isWxLogin) {
                                Toast({
                                    message: '长按图片保存',
                                    duration: 3000
                                });
                                this.show = true;
                                this.images[0] = this.imgUrl;
                            } else {
                                let eleLink = document.createElement("a");
                                eleLink.href = this.imgUrl; // 转换后的图片地址
                                eleLink.download = "【" + this.detail.trackingNumber + "】电子凭证";
                                document.body.appendChild(eleLink);
                                // 触发点击
                                eleLink.click();
                                // 然后移除
                                document.body.removeChild(eleLink);
                            }
                        }
                        image.src = imgUrl;
                    })
                })
                this.title = '运单信息';
            },
            //去支付
            gopayment() {
                this.$router.push({
                    path: '/defrayments',
                    query: {
                        id: this.detail.id,
                        flag: this.flag
                    }
                })
            },
            /*查看提货码*/
            checkDeliveryCode() {
                this.$router.push("/cargoYards")
            },
            // 获取数据
            getDetail() {
                let params = {
                    params: this.trackingId
                }
                this.$axios.post('merchant/getTrackingInfo', params).then(res => {
                    if (res.data.code === 200) {
                        let data = res.data.data;
                        this.detail = data;
                        if (this.flag == 1) {
                            this.detail.yingfu = this.detail.totalFee
                        } else if (this.flag == 2 && this.detail.payMeansId == '2') {
                            this.detail.yingfu = this.detail.totalFee + this.detail.collectMoney
                        } else if (this.flag == 2 && this.detail.payMeansId == '1') {
                            this.detail.yingfu = this.detail.collectMoney
                        } else {
                            this.detail.yingfu = ""
                        }
                    }
                });
            },
            // 物流跟踪
            clickLogistics() {
                this.$router.push("/search/logistics/" + this.detail.trackingNumber);
            },
            handleCopyClick(text, tip) {
                this.$copyText(text).then(
                    () => {
                        Toast({
                            message: tip + "复制成功！",
                            duration: 1000
                        });
                    },
                    () => {
                        Toast({
                            message: tip + "复制失败！",
                            duration: 1000
                        });
                    }
                );
            }
        }
    }
</script>


<style lang="scss">
    .tracking-detail {
        .tracking-detail__info {
            background-color: #fff;
            margin-bottom: 0.13rem;

            .info-flex {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }

            .info-padding {
                padding-left: 0.31rem;
                padding-right: 0.31rem;
            }

            .info-title {
                font-size: 0.4rem;
                color: #2D2D2D;
                height: 1.07rem;
                border-bottom: 1px solid #E5E5E5;

                .generating {
                    color: #FE9329;
                }
            }

            .info-content {
                font-size: 0.37rem;
                color: #4F4F4F;
                height: 0.67rem;
            }

            .info-service {
                border-top: 1px solid #E5E5E5;
                font-size: 0.37rem;
                color: #4F4F4F;
                height: 1.01rem;
            }
        }

        .tracking-detail__goods {
            margin-bottom: 0.13rem;

            .service-item {
                padding: 0.2rem 0.31rem 0.2rem 0.31rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                font-size: 0.37rem;
                color: #4F4F4F;
            }
        }

        .tracking-detail__pay {
            background-color: #fff;

            .pay-item {
                padding: 0.2rem 0.31rem 0.2rem 0.31rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                font-size: 0.37rem;
                color: #4F4F4F;
            }
        }

        .follow-btn {
            width: 1.87rem;
            height: 0.64rem;
            line-height: 0.64rem;
            border-radius: 0;
        }

        .voucher-btn {
            margin-top: 0.3rem;
            width: 2.5rem;
            height: 0.84rem;
            line-height: 0.64rem;
            border-radius: 0;
        }

        .btn-copy {
            -webkit-transform: translateY(2px);
            -moz-transform: translateY(2px);
            -ms-transform: translateY(2px);
            -o-transform: translateY(2px);
            transform: translateY(2px);
            margin-left: 0.1rem;
            color: #FE9329;
        }
    }

    .payment-btn {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1.17rem;
        z-index: 9;

        div {
            float: left;
        }

        .left {
            width: 6.53rem;
            height: 1.17rem;
            background-color: #fff;
            padding: 0 .57rem;
            box-sizing: border-box;

            p {
                float: left;
                line-height: 1.17rem;
            }

            p:first-child {
                width: 59.7%;
                font-size: 0.37rem;
                color: rgba(79, 79, 79, 1);

                span {
                    color: #E52323;
                    font-size: 0.27rem;
                }

                span:last-child {
                    font-family: PingFang-SC-Medium;
                    font-weight: 500;
                    color: rgba(229, 35, 35, 1);
                    font-size: 0.4rem;
                }
            }

            p:last-child {
                width: 39%;
                text-align: center;
                font-size: 0.32rem;
                color: rgba(79, 79, 79, 1);

                span {
                    color: #E73838;
                }
            }

            .border {
                width: 0.03rem;
                height: 0.8rem;
                background: rgba(143, 143, 143, 1);
                margin-top: .18rem;
            }
        }

        .right-btn {
            width: 3.47rem;
            background-color: rgb(254, 147, 41);
            font-size: 0.48rem;
            font-family: PingFang-SC-Medium;
            height: 100%;
            text-align: center;
            line-height: 1.17rem;
            color: rgb(255, 255, 255);
        }

        .con {
            background-color: rgb(147, 147, 147);
        }
    }

</style>
